const isDevelopment = process.env.NODE_ENV === 'development';

const checkKeys = (pattern: string, params: {}) => {
  Object.keys(params).forEach((key) => {
    if (pattern.indexOf(`:${key}`) < 0) {
      console.warn(
        `Unknown parameter :${key} in pattern ${pattern}. (Maybe you wanted to pass <routes>.<route>.url instead of <routes>.<route>.)`,
      );
    }
  });
};

const preserveEndingSlash = (pattern: string, reversed: string) => {
  const endingSlashRe = /\/$/;

  const shouldHave = endingSlashRe.test(pattern);
  const has = endingSlashRe.test(reversed);

  if (shouldHave && !has) {
    return `${reversed}/`;
  }
  if (!shouldHave && has) {
    return reversed.slice(0, reversed.length - 1);
  }

  return reversed;
};

export const reverse = (pattern: string, params = {}) => {
  if (isDevelopment) {
    checkKeys(pattern, params);
  }
  const reversed = pattern
    .replace(/\w*(:\w+\??)/g, (path, param) => {
      const key = param.replace(/[:?]/g, '');
      if (params[key] === undefined) {
        if (param.indexOf('?') < 0) {
          if (isDevelopment) {
            console.warn(`Required parameter ${key} is missing for ${pattern}`);
          }
          return path;
        }
        return '';
      }
      return path.replace(param, params[key]);
    })
    .replace(/\/\//, '/');
  return preserveEndingSlash(pattern, reversed);
};

export function url<TReverseArgs extends object | {}>(urlString: string, baseURL: string = ''): URLType<TReverseArgs> {
  const fullUrl = baseURL + urlString;
  const result = (reverseArgs?: TReverseArgs) =>
    reverse(fullUrl, baseURL.includes(':lang') ? { lang: window.appState.lang, ...reverseArgs } : reverseArgs);

  // Remove query params from the URL (because react-router won't work with them in app_index for example)
  result.url = fullUrl.split('?')[0];
  return result;
}

export function i18nUrl<TReverseArgs extends object>(urlString: string) {
  return url<TReverseArgs>(urlString, '/:lang');
}
